var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { connect } from '@/overmind';
import Modal from 'components/Modal.vue';
import { NotificationService } from '@/services/NotificationService';
import { mixpanelTracking } from '@/services/mixpanel';
let DataValidationModal = class DataValidationModal extends Vue {
    constructor() {
        super(...arguments);
        this.currentStep = 0;
        this.options = [];
        this.selectedOptions = [];
        this.loading = false;
    }
    mounted() {
        mixpanelTracking('Validação: Modal de validação foi renderizado');
        if (this.pendingToRequest.emails) {
            this.options.push('E-mail');
        }
        if (this.pendingToRequest.phones) {
            this.options.push('Telefone');
        }
    }
    close() {
        this.show = false;
        this.$emit('close', { continue: true });
    }
    finish() {
        this.show = false;
        this.tracking('Validação: Usuário clicou em Finalizar no modal de confirmação de solicitação');
        this.$emit('close', { continue: false });
    }
    async submit() {
        this.tracking('Validação: Usuário clicou Iniciar validação no modal de canais');
        // @ts-ignore
        const valid = await this.$refs.form.validate();
        if (!valid)
            return;
        let phoneResult = true;
        let emailResult = true;
        this.loading = true;
        if (this.selectedOptions.includes('Telefone')) {
            phoneResult = await this.requestPhoneValidation();
        }
        if (this.selectedOptions.includes('E-mail')) {
            emailResult = await this.requestEmailValidation();
        }
        this.loading = false;
        if (phoneResult && emailResult) {
            this.nextButtonAction();
            this.tracking('Validação: Modal de confirmação de solicitação foi renderizado');
        }
    }
    async requestPhoneValidation() {
        this.options = this.options.filter(o => o != 'Telefone');
        this.selectedOptions = this.selectedOptions.filter(o => o != 'Telefone');
        this.$emit('openPhoneValidationModal');
        return true;
    }
    async requestEmailValidation() {
        // @ts-ignore
        const result = await this.companyActions.newValidateEmails(this.infoset.id);
        if (result.status == 200) {
            NotificationService.success('Sucesso', 'Solicitação para validação de e-mails enviada com sucesso!');
            this.options = this.options.filter(o => o != 'E-mail');
            this.selectedOptions = this.selectedOptions.filter(o => o != 'E-mail');
            return true;
        }
        else {
            NotificationService.error('Erro', result.data.error || 'Ocorreu um erro inesperado');
            return false;
        }
    }
    nextButtonAction() {
        this.currentStep += 1;
    }
    get header() {
        switch (this.currentStep) {
            case 0:
                return 'Opa, sua lista está desatualizada';
            case 1:
                return 'Valide os dados para contato';
            case 2:
                return 'Sua lista está em validação';
            default:
                return '';
        }
    }
    addOptionInSelect(item) {
        this.tracking(`Validação: Usuário selecionou ${item.value} no modal de canais`);
        if (this.selectedOptions.length == this.options.length - 1) {
            // @ts-ignore
            this.$refs.select.hidePopup();
        }
    }
    tracking(msg) {
        mixpanelTracking(msg);
    }
};
__decorate([
    PropSync('open', { default: false })
], DataValidationModal.prototype, "show", void 0);
__decorate([
    Prop({ default: () => { } })
], DataValidationModal.prototype, "infoset", void 0);
__decorate([
    Prop({ default: () => { } })
], DataValidationModal.prototype, "pendingToRequest", void 0);
DataValidationModal = __decorate([
    Component(connect(({ actions, state }) => ({
        actions: actions.infosets,
        userActions: actions.users,
        companyActions: actions.companies,
        calculateCompaniesOnTotvsFetching: state.users.calculateCompaniesOnTotvsFetching,
    }), {
        name: 'DataValidationModal',
        components: {
            Modal,
        },
    }))
], DataValidationModal);
export default DataValidationModal;
